import React from 'react';


export const EmptyTableMsg = (props) => {

    let modifierClass = props.modifierClass || '';

    return  (
        <div className={`empty-table-msg ${modifierClass}`}>
            {props.emptymsg}
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/EmptyTableMsg.js